import(/* webpackMode: "eager" */ "/vercel/path0/app/globals.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/font/google/target.css?{\"path\":\"app/layout.tsx\",\"import\":\"Inter\",\"arguments\":[{\"subsets\":[\"latin\"],\"display\":\"swap\"}],\"variableName\":\"inter\"}");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/@fontsource/source-sans-pro/index.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/ui/providers.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ReactQueryDevtoolsForProduction"] */ "/vercel/path0/ui/react-query-dev-tools-for-production.tsx");
